import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is defined in your config
import { useNavigate } from 'react-router-dom';

const ItemWeighmentsList = () => {
    const [itemWeighments, setItemWeighments] = useState([]);
    const [filteredItemWeighments, setFilteredItemWeighments] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        fetch(`${BASE_URL}itemweighments`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 'success') {
                    setItemWeighments(data.data);
                    setFilteredItemWeighments(data.data);
                }
            })
            .catch(error => console.error('Error fetching item weighments:', error));
    }, []);

    const handleSearchChange = (event) => {
        const term = event.target.value;
        setSearchTerm(term);

        const filtered = itemWeighments.filter(item =>
            item.item.toLowerCase().includes(term.toLowerCase())
        );
        setFilteredItemWeighments(filtered);
    };

    const handleEdit = (id) => {
        navigate(`/EditItemWeighments/${id}`);
    };

    const handleAdd = () => {
        navigate('/\AddItemWeighments');
    };

    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this item weighment?")) {
            fetch(`${BASE_URL}itemweighments/${id}`, {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' },
            })
                .then(response => response.json())
                .then(data => {
                    if (data.status === 'success') {
                        setItemWeighments(itemWeighments.filter(item => item.id !== id));
                        setFilteredItemWeighments(filteredItemWeighments.filter(item => item.id !== id));
                    }
                })
                .catch(error => console.error('Error deleting item weighment:', error));
        }
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Item Weighments List</h3>
                        </div>
                        <div className="col-12 col-md-6 order-md-2 order-first">
                            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                                <ol className="breadcrumb"></ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row" id="basic-table">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-md-6"></div>
                                    <div className="col-md-6 text-end">
                                        <button className="btn btn-primary" onClick={handleAdd}>Add Item Weighment</button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="mb-3">
                                    <label htmlFor="searchTerm" className="form-label">Search by Item</label>
                                    <input
                                        type="text"
                                        id="searchTerm"
                                        className="form-control"
                                        placeholder="Search item"
                                        value={searchTerm}
                                        onChange={handleSearchChange}
                                    />
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-lg">
                                        <thead>
                                            <tr>
                                                <th>ITEM</th>
                                                <th>BARCODE</th>
                                                <th>WEIGHT</th>
                                                <th className="text-end">ACTION</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredItemWeighments.map(item => (
                                                <tr key={item.id}>
                                                    <td>{item.item || 'N/A'}</td>
                                                    <td>{item.barcode || 'N/A'}</td>
                                                    <td>{item.weight || 'N/A'}</td>
                                                    <td className="text-end">
                                                        <button className="btn btn-success" onClick={() => handleEdit(item.id)}>Edit</button>
                                                        <button className="btn btn-danger ms-2" onClick={() => handleDelete(item.id)}>Delete</button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ItemWeighmentsList;
